import React from 'react';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Modal } from 'antd';

import FooterModal from './FooterModal';

import styles from './BaseModal.module.scss';

const BaseModal = ({
    isModalVisible,
    handleCancel,
    title,
    children,
    form,
    onDelete,
    isEditing,
    width = '1020px',
    disableSave,
    disableDelete,
    loadingServiceGroup,
    customStyle = {},
    customFooter,
    okText,
    hideSave,
    loading = false,
    noBodyPadding = false,
    bodyStyle,
}) => {
    const translate = useTranslate();

    return (
        <Modal
            title={
                <div className={styles.title}>
                    <span className={styles.titleChild}>{title}</span>
                </div>
            }
            maskClosable={false}
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            // centered
            destroyOnClose={true}
            width={width}
            zIndex={99999}
            style={{
                top: 40,
                paddingBottom: 0,
                ...customStyle,
            }}
            className={styles.modalCustom}
            wrapStyle={{ overflow: 'hidden' }}
            styles={{
                content: {
                    maxHeight: 'calc(100vh - 80px)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    padding: 0,
                    borderRadius: 0,
                },
                body: {
                    padding: 0,
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    ...bodyStyle,
                },
            }}
        >
            <div
                style={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    padding: noBodyPadding ? '0' : '20px',
                }}
            >
                {children}
            </div>

            <div
                style={{
                    flexShrink: 0,
                    borderTop: '1px solid #e8e8e8',
                    background: '#fff',
                    padding: '0px 0px 0px 16px',
                }}
            >
                {customFooter !== undefined ? (
                    customFooter
                ) : (
                    <FooterModal
                        loading={loading}
                        handleCancel={handleCancel}
                        form={form}
                        handleSave={() => form.submit()}
                        onDelete={onDelete}
                        isEditing={isEditing}
                        isCustomPage={true}
                        disableSave={disableSave}
                        disableDelete={disableDelete}
                        hideSave={hideSave}
                        label={
                            okText ||
                            (isEditing
                                ? translate.formatMessage(commonMessage.update)
                                : translate.formatMessage(commonMessage.create))
                        }
                    />
                )}
            </div>
        </Modal>
    );
};

export default BaseModal;
